import { render, staticRenderFns } from "./PageEditorHtml.vue?vue&type=template&id=488cca78&"
import script from "./PageEditorHtml.vue?vue&type=script&lang=js&"
export * from "./PageEditorHtml.vue?vue&type=script&lang=js&"
import style0 from "./PageEditorHtml.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports